// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sf-1";
export var stateContainer = "_sf-0";